import { Dictionary } from '@reduxjs/toolkit';
import { FieldGroup, FieldType } from 'components/molecules/views';
import { FilterableField } from 'components/organisms/tasks/fields';
import { GroupBy } from '../group-by';

export const toGroup = ({
  fieldName,
  fieldId,
  customField,
}: FilterableField): FieldGroup | undefined => {
  if (fieldName === GroupBy.None) {
    return undefined;
  }

  if (customField) {
    return {
      fieldId,
      fieldClass: FieldType.Custom,
    };
  }

  return {
    name: fieldName,
    fieldClass: FieldType.Native,
  };
};

export const fromGroup =
  (lookupByFieldId: Dictionary<FilterableField>) =>
  (group?: FieldGroup): string => {
    switch (group?.fieldClass) {
      case FieldType.Custom:
        return lookupByFieldId[group.fieldId]?.fieldName ?? GroupBy.None;
      case FieldType.Native:
        return group.name;
      default:
        return GroupBy.None;
    }
  };
